module.exports = __webpack_public_path__ + "static/media/boxes.8fd28f59.png";